const Authorized = ({ configPerm, children, authority, noMatch }) => {
  if (!authority && Object.keys(configPerm).length === 0) {
    // still loading
    return null;
  }

  if (authority === true || (Array.isArray(authority) && authority.some(permission => configPerm[permission]))) {
    return typeof children === "undefined" ? null : children;
  }

  return noMatch;
};

export default Authorized;
